// @flow

import React from 'react';
import type { Option } from './ControlledMultiselect';
import ControlledMultiselect from './ControlledMultiselect';

export type Props = {
  options: Option[],
  id: string,
  name?: string,
  placeholder?: string,
  onChange?: (items: Option[]) => void,
  labelText?: string,
  large?: boolean,
  showActionButtons?: boolean,
};

const Multiselect = ({
  options,
  onChange,
  ...rest
}: Props): React$MixedElement => {
  const [selectedItems, setSelectedItems] = React.useState(
    options.filter((option) => option.selected),
  );

  // put the new values in the actual hidden mutliselect so the form can be submitted via vanilla js
  const handleChange = (items: Option[]) => {
    const $select: any = document.getElementById(rest.id);
    const $options = Array.from($select.options).forEach((option) => {
      const o = option;
      const i = items.map((item) => item.value);
      // eslint-disable-next-line no-param-reassign
      option.selected = i.includes(option.value);
    });
  };
  const handleSet = (items: Option[]) => {
    setSelectedItems(items);
    handleChange(items);
  };

  return (
    <ControlledMultiselect
      options={options}
      selectedItems={selectedItems}
      setSelectedItems={handleSet}
      {...rest}
    />
  );
};

export default Multiselect;
